export enum BUDGET_PAGES {
  PHONE_PAGE,
  ONBOARDING_PAGE,
  HOW_IT_WORKS_PAGE,
  BUDGET_REQUEST_FORM_PAGE,
  INCREASE_LIMIT_ONBOARDING_PAGE,
  BUDGET_RESPONSE_PAGE,
}
